import React from "react";

import { Box, Grid, Typography } from "@mui/material";

import mainStyles from "../../../../styles";

interface SubscriptionActionProps {
  title?: string;
  displayInfo?: React.ReactNode;
  middleElem?: React.ReactNode;
  toolTip?: React.ReactNode;
  children: React.ReactNode;
}

const SubscriptionAction = ({
  title,
  displayInfo,
  middleElem,
  children,
  toolTip,
}: SubscriptionActionProps) => {
  const classes = mainStyles();

  return (
    <Grid container alignItems="center" sx={classes.spaceBottomSmall}>
      <Grid item xs={3}>
        <Typography
          align="left"
          sx={{
            ...classes.spaceTop,
            ...classes.spaceLeft,
            ...classes.tableTypography,
          }}
          data-testid="label-subscription-property-display"
        >
          <Box component="span" fontWeight="fontWeightBold">
            {title}
          </Box>{" "}
          {toolTip}
          {displayInfo}
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        container
        justifyContent="center"
        data-testid="label-subscription-property-display-middle"
      >
        {middleElem}
      </Grid>
      <Grid item xs={3} sx={classes.padLeftLarge}>
        <Grid container justifyContent="flex-end">
          {children}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SubscriptionAction;
